import React from 'react'
import PropTypes from 'prop-types'
import {
    useMultiStyleConfig,
    Flex,
    Button,
    Box,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {LegalLinksSeparator} from '../icons/shared'

const LegalLinks = ({links}) => {
    const styles = useMultiStyleConfig('Footer')
    const {buildUrl} = useMultiSite()

    return (
        <Flex {...styles.legalLinks}>
            {links?.map(({link, is_external_url}, index) => {
                const isExternalUrl = !!is_external_url
                const isFirstLink = index === 0

                return (
                    <Flex key={index} {...styles.legalLinkFlex}>
                        {!isFirstLink && (
                            <Box {...styles.legalLinksSeperatorContainer}>
                                <LegalLinksSeparator {...styles.legalLinksSeperator} />
                            </Box>
                        )}

                        <Button
                            as="a"
                            variant="link-button-no-underline"
                            size="small"
                            href={isExternalUrl ? link?.href : buildUrl(link?.href)}
                            target={isExternalUrl ? '_blank' : undefined}
                            rel={isExternalUrl ? 'noopener noreferrer' : undefined}
                            {...styles.legalLink}
                        >
                            {link?.title}
                        </Button>
                    </Flex>
                )
            })}
        </Flex>
    )
}

LegalLinks.propTypes = {
    links: PropTypes.arrayOf(
        PropTypes.shape({
            link: PropTypes.shape({title: PropTypes.string, href: PropTypes.string}),
            is_external_url: PropTypes.bool,
        }),
    ),
}

export default LegalLinks
